import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Grid } from "@material-ui/core";

function Projects() {
  return (
    <Row
      className="spacingMin differentColor"
      style={{ marginLeft: "0px", marginRight: "0px" }}
    >
      <div
        style={{
          maxWidth: "1140px",
          marginLeft: "auto",
          marginRight: "auto",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <Col md={12}>
          <div className="titleProcess">Projects</div>
        </Col>

        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <a href="https://linktr.ee/proximy/" target="_blank">
              <div className="darkendBox"></div>
              <img
                src="https://images.pexels.com/photos/853168/pexels-photo-853168.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                className="projectImages"
              />
              <div className="titleApps">Proximy</div>
            </a>
          </div>
        </Col>
        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <a href="https://linkbase.ca/" target="_blank">
              <div className="darkendBox"></div>
              <img
                src="https://images.pexels.com/photos/163125/board-printed-circuit-board-computer-electronics-163125.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                className="projectImages"
              />
              <div className="titleApps">Linkbase</div>
            </a>
          </div>
        </Col>
        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <a href="https://twentyfourr.com/" target="_blank">
              <div className="darkendBox"></div>
              <img
                src="https://images.pexels.com/photos/4246120/pexels-photo-4246120.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                className="projectImages"
              />
              <div className="titleApps">Twenty Fourr</div>
            </a>
          </div>
        </Col>

        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <a href="https://www.blueskywinery.ca/" target="_blank">
              <div className="darkendBox"></div>
              <img
                src="https://images.pexels.com/photos/434311/pexels-photo-434311.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                className="projectImages"
              />
              <div className="titleApps">Blue Sky Winery</div>
            </a>
          </div>
        </Col>
        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <a href="https://katclub.ca/" target="_blank">
              <div className="darkendBox"></div>
              <img
                src="https://images.unsplash.com/photo-1568585219057-9206080e6c74?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80"
                className="projectImages"
              />
              <div className="titleApps">Kat Club</div>
            </a>
          </div>
        </Col>
        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <div className="darkendBox"></div>
            <img
              src="https://images.pexels.com/photos/2982426/pexels-photo-2982426.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              className="projectImages"
            />
            <div className="titleApps">Loop It</div>
          </div>
        </Col>
        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <a href="https://finebasket-bc15a.web.app" target="_blank">
              <div className="darkendBox"></div>
              <img
                src="https://images.pexels.com/photos/3962285/pexels-photo-3962285.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                className="projectImages"
              />
              <div className="titleApps">Fine Basket</div>
            </a>
          </div>
        </Col>
        <Col md={4} data-aos={"fade-up"} className="noPadMob">
          <div className="itemBox">
            <div className="darkendBox"></div>
            <img
              src="https://compilelabs.s3.ca-central-1.amazonaws.com/enactus/18527402_898028913670441_8732288374875443984_o.jpg"
              className="projectImages"
            />
            <div className="titleApps">Enactus UBCO</div>
          </div>
        </Col>
      </div>
    </Row>
  );
}

export default Projects;
